import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { PoweredBy } from "@/components/AppShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth, useTheme } from "@/context/AppContext";
import { errorText } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  useTheme();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/overview" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col">
    <div className="flex flex-1 items-center justify-center px-4">
      <div className="w-full max-w-sm fade-in">
        <div className="mb-8 flex flex-col items-center text-center">
          <img src="/lpt2-logo.png" alt="LPT2" className="mb-5 h-12 w-auto" data-testid="login-logo" />
          <h1 className="text-2xl font-semibold tracking-tight sm:text-3xl">LPT2 Traffic Operations</h1>
          <p className="mt-2 text-sm text-muted-foreground">Video Incident Detection System · Lebuhraya Pantai Timur 2</p>
        </div>
        <form onSubmit={submit} className="surface space-y-4 p-6" data-testid="admin-login-form">
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-username-input" className="h-11 rounded-xl" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" autoComplete="current-password" required value={password}
              onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" className="h-11 rounded-xl" />
          </div>
          {error && <p className="text-sm text-[hsl(var(--bad))]" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={busy} className="h-11 w-full rounded-xl text-sm font-medium" data-testid="admin-login-submit-button">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}
          </Button>
        </form>
        <p className="mt-6 flex items-center justify-center gap-1.5 text-xs text-muted-foreground">
          <Lock className="h-3 w-3" /> Operator and administrator accounts are created by your administrator.
        </p>
      </div>
    </div>
    <PoweredBy />
    </div>
  );
}
